import { ReactElement } from 'react';
import useConfig from '../../hooks/ui/useConfig';
import classNames from 'classnames';
import useScreenType from '../../hooks/utility/useScreenType';

interface Props {
  className?: string;
}

export default function CompanyLogo({ className }: Props): ReactElement {
  const { logo_url } = useConfig();
  const { isMobile } = useScreenType();

  return logo_url ? (
    <img
      src={logo_url}
      alt="Logo"
      className={classNames(
        'h-12 flex object-contain',
        {
          '!h-8': isMobile,
        },
        className,
      )}
    />
  ) : null;
}
